import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { ICreateSubRouteFrequency } from './interfaces/create-sub-route-frequency.interface';
import FrequenciesAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { BusinessPartnerService } from 'app/modules/components/business-partners/business-partner/business-partner.service';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-subroute-frequency-modal',
  styleUrl: './sub-route-frequency.component.scss',
  templateUrl: './sub-route-frequency.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
  ],
})
export class AddSubRouteFrequency {
  currentCreateSubRouteFrequency: ICreateSubRouteFrequency = this.initializeCreateSubRouteFrequency();
  currentUpdateSubRouteFrequency: FrequenciesAttributes | undefined;

  daysList: { day: string; value: number }[] = [
    { day: 'Lunes', value: 1 },
    { day: 'Martes', value: 2 },
    { day: 'Miércoles', value: 3 },
    { day: 'Jueves', value: 4 },
    { day: 'Viernes', value: 5 },
    { day: 'Sábado', value: 6 },
    { day: 'Domingo', value: 7 }
  ];
  businessPartnerList: BusinessPartnerAttributes[] = [];
  newDate: Date | null = null;
 isEditMode : boolean;
 isLoading = false;
showDateField: boolean = false; 

 filterText: string = '';
 filteredBusinessPartnerList = this.businessPartnerList;
 selectedPartners: { id: number; name: string }[] = [];
 selectedDates: Date[] = [];
  

  constructor(
    private readonly businessPartnerService: BusinessPartnerService,
    public dialogRef: MatDialogRef<AddSubRouteFrequency>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Optional: if you want to pass data
    private snackBar: MatSnackBar
  ) {
    this.isEditMode = !!data; 
    if (this.isEditMode) {
      this.currentCreateSubRouteFrequency = { 
        ...data,
        dates: data.dates[0], 
        businessPartners: data.businessPartners.map((b) => b.businessPartner._id.toString()),
      };
    if(this.currentCreateSubRouteFrequency.type!=='W'){
      this.showDateField=true; 
    }
    }
  }

  
  ngAfterViewInit(): void {
    this.fetchAllBusinessPartner();
  }
  filterBusinessPartners() {
    let business:any;
    const filterValue = this.filterText.toLowerCase();
    this.filteredBusinessPartnerList = this.businessPartnerList.filter(partner =>
      partner.name.toLowerCase().includes(filterValue)
    );
  }

  private fetchAllBusinessPartner(): void {
    this.isLoading = true;
    this.businessPartnerService.findToComboBox([]).subscribe({
      next: (res) => {
        this.businessPartnerList = res.data;
        this.isLoading=false;
        this.filteredBusinessPartnerList = this.businessPartnerList;
      },
      error: (err) => {
        this.isLoading=false;
        this.snackBar.open(err.error.message || "Error al obtener socios de negocios.","Cerrar",{ duration: 5000});
      }
    });
  }


  private initializeCreateSubRouteFrequency(): ICreateSubRouteFrequency {
    return {
        days: [],
        dates:[],
        businessPartners: [],
    };
  }

    onDateChange(event: any) {
      const selectedDate = event.value;
      if (!this.selectedDates.includes(selectedDate)) {
        this.selectedDates.push(selectedDate);
      }
    }
  
    removeDate(date: Date) {
      const index = this.selectedDates.indexOf(date);
      if (index !== -1) {
        this.selectedDates.splice(index, 1);
      }
    }
  

onTypeChange(selectedType: string) {
  this.showDateField = selectedType !== 'W'; 
}


  save() {
    const dataToSend = Object.entries(this.currentCreateSubRouteFrequency)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }
}
